import { Add } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { FC } from 'react';

import { useNavigateDialogForm } from '../../../components/formikDialogForm/dialogForm.hook';
import { VisibleIfAdmin } from '../../auth/components/VisibleIfAdmin';

import { KundeTable } from './KundeTable';

export const KundeListScreen: FC = () => {
  const navigateDialog = useNavigateDialogForm('kunde', 'create');

  return (
    <div>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Kunden
      </Typography>
      <VisibleIfAdmin>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<Add />}
          onClick={() => navigateDialog()}
          sx={{ mb: 3 }}
        >
          Neuer Kunde
        </Button>
      </VisibleIfAdmin>
      <KundeTable />
    </div>
  );
};
